import ApplicationController from './application_controller';

export default class extends ApplicationController {
  static targets = ['autocomplete'];

  connect() {
    this.autocompleteTarget.addEventListener('awc-autocomplete:commit', this.switchUser.bind(this));
  }

  switchUser(event) {
    const userId = event.detail.target.attributes.value.nodeValue;
    if (userId) {
      const scopeIdentifier = `user_${userId}`;
      window.location.href = `/switch_user?scope_identifier=${encodeURIComponent(scopeIdentifier)}`;
    }
  }
}
